<template>
<v-card style="height:400px;">
    <v-card-title class="pb-0">
        My Meetings
        <v-icon v-if="!loading" @click="loadItems()">refresh</v-icon>
    </v-card-title>

    <v-progress-linear indeterminate v-if="loading"></v-progress-linear>

    <v-card-text>
        <v-list v-if="items.length" style="height:320px;overflow-y:auto;">
            <v-list-item
                v-for="item in items"
                :key="item.id"
                style="border-bottom: 1px solid #ddd !important;"
                @click="$emit('viewEvent',item.id)"
                class="px-0"
                dense
                :class="item.cancelled ? 'grey lighten-3' : ''"
            >
                <v-list-item-content>
                    <v-list-item-title>
                        {{ item.title }}
                        <v-chip label x-small outlined color="red" v-if="item.cancelled" class="mr-1 px-1">CANCELLED</v-chip>
                        <v-icon v-if="item.online" label small color="green" outlined>mdi-circle</v-icon>
                    </v-list-item-title>
                    <v-list-item-subtitle class="d-flex flex-column flex-sm-row justify-space-between overflow-wrap">
                        <span v-if="item.room">
                            <v-icon small color="primary">mdi-map-marker</v-icon> {{ item.room ? item.room.name_eng : '-' }}
                        </span>
                        <span v-if="item.start">
                            <v-icon small color="primary">mdi-calendar-outline</v-icon>
                            {{ (new Date(item.start)).toLocaleString('en-GB').substr(0,17) }}
                            <!-- {{ (new Date(item.end)).toLocaleString('en-GB').substr(0,17) }} -->
                        </span>
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-list>

        <div v-else class="d-flex justify-center align-center grey--text" style="height:320px">
            No upcoming meetings..
        </div>
    </v-card-text>
</v-card>
</template>

<script>

export default {
    data(){return {
        loading: false,
        items: [],
    }},
    watch: {
        '$route.query.page'() {
            this.loadItems()
        }
    },
    methods: {
        loadItems(){
            this.loading = true
            return this.$axios.get(`/api/my-meetings?week=true`).then(res => {
            // return this.$axios.get(`/api/meetings/getMyMeetings?week=true`).then(res => {
                this.items = res.data
            }).finally(() => this.loading = false)
        },
        changePage(value) {
            this.$router.push({query: { ...this.$route.query, page: value}})
        },
    },
    created(){
        this.loadItems()
    }
}
</script>